import { NgModule } from '@angular/core';
import { ScrollPositionDirective } from './scroll-position.directive';

@NgModule({
  declarations: [ScrollPositionDirective],
  exports: [ScrollPositionDirective],
})
export class ScrollPositionDirectiveModule {}
